import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import AppRouter from 'pages/AppRouter';
import useSplashScreen from 'hooks/useSplashScreen';
import commonMessages from 'messages/common';
import useDocTitle from 'hooks/useDocTitle';
import moment from 'moment';
import 'moment/locale/ko';

// esline-disable-next-line
moment.locale('ko');

const App: React.FC = () => {
  const intl = useIntl();
  useDocTitle(intl.formatMessage(commonMessages.quantastic));
  useSplashScreen();
  return (
    <>
      <AppRouter />
      <Helmet>
        <html lang={intl.locale} />
      </Helmet>
    </>
  );
};

export default App;
